"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var neuron_1 = __importDefault(require("./neuron"));
var Layer = /** @class */ (function () {
    function Layer(numberOfNeurons) {
        var neurons = [];
        for (var j = 0; j < numberOfNeurons; j++) {
            // const value = Math.random()
            var neuron = new neuron_1.default();
            // Neurons in other than initial layer have a bias value
            neurons.push(neuron);
        }
        this.neurons = neurons;
    }
    Layer.prototype.toJSON = function () {
        return this.neurons.map(function (n) {
            return n.toJSON();
        });
    };
    return Layer;
}());
exports.default = Layer;
